angular.module("ainapp")
    .controller("LeaveAllocationController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {


            $scope.PageName = "Leave Allocation";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.Grades = [];
            MainService.GradesInDropdown().then(function (response) {
                $scope.Grades = response.data;
            });

            $scope.Employees = [];
            MainService.EmployeesInDropdown().then(function (response) {
                $scope.Employees = response.data;
            });

            $scope.Components = [];
            MainService.LeavePayrollComponentsList().then(function (response) {
                $scope.Components = response.data;
            });


            $scope.Init = function () {

                $scope.addData = {
                    GradeId: "",
                    PayrollComponentId: "",
                    FinancialYearId: "",
                    EmployeeId: "",
                    Leaves: 0,
                    IsEmployeeWise: false,
                }

                $scope.load = 0;

            }
            $scope.Init();

            $scope.KendoSource = new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function (o) {
                        MainService.LeaveAllocationInView(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error($scope.LanguageData.NetworkError);
                        })
                    },

                },
                change: function (data) {},
                schema: {
                    data: "Data",
                    total: "Total",
                    model: {
                        id: "Id",
                        fields: {
                            "Grade.Name": {
                                type: "string",
                                editable: false,
                            },
                            "Employee.Name": {
                                type: "string",
                                editable: false,
                            },
                            "PayrollComponent.Name": {
                                type: "string",
                                editable: false,
                            },
                            Leaves: {
                                type: "number",
                                editable: false,
                            },
                            IsEmployeeWise: {
                                type: "boolean",
                                editable: false,
                            },


                        }
                    }
                },
                serverPaging: true,
                serverSorting: true,
                serverFiltering: true,
                pageSize: 20,
            });

            $scope.KendoGridOptions = {

                editable: false,
                pageable: true,
                toolbar: ["excel"],
                height: 600,
                resizable: true,
                dataSource: $scope.KendoSource,
                pageSize: 20,
                pageable: {
                    input: false,
                    refresh: true,
                    pageSizes: true,
                    info: true,
                },
                sortable: true,
                scrollable: true,
                filterable: true,
                groupable: true,
                columnMenu: {
                    filterable: false,
                    filterable: true,
                },
                columns: [
                    {
                        field: "Grade.Name",
                        title: "Grade",
                        headerTemplate: "{{LanguageData.Grade}}",

                        },
                    {
                        field: "Employee.Name",
                        title: "Employee",
                        headerTemplate: "{{LanguageData.Employee}}",

                        },
                    {
                        field: "PayrollComponent.Name",
                        title: "Leave Type",
                        headerTemplate: "{{LanguageData.LeaveType}}  ",

                        },
                    {
                        field: "Leaves",
                        title: "Leaves",
                        headerTemplate: "{{LanguageData.Leaves}}  ",

                        }, {
                        field: "IsEmployeeWise",
                        title: "Employee Wise",
                        template: "<p ng-if='dataItem.IsEmployeeWise'>Yes</p>"

                        },
                    {
                        title: "Options",
                        headerTemplate: "{{LanguageData.Options}}  ",
                        template: "<button class=' btn-default btn-sm fa fa-pencil' ng-click='Edit(dataItem)'> </button> <button class=' btn-default btn-sm fa fa-trash' ng-click='DeleteAccType(dataItem)'> </button>",
                        width: '80px'
                    },
                    ],
            };

            $scope.Update = function () {
                $("#Kendo-Grid").data("kendoGrid").dataSource.sync();
            }
            $scope.Cancel = function () {
                $("#Kendo-Grid").data("kendoGrid").dataSource.cancelChanges();
            }

            $scope.SelectedDataForDelete = {};
            $scope.DeleteAccType = function (data) {
                if (!$scope.PageAccessInfo.IsRemove) {
                    toastr.info("You Dont Have Access To Delete Data, Please Contact Admin");
                } else {
                    $scope.SelectedDataForDelete = data;
                    $("#deleteModal").modal("show");
                }
            }

            $scope.deleteWithConfirm = function () {
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.DeleteLeaveAllocation($scope.SelectedDataForDelete.Id).then(function (response) {
                    if (response.data) {
                        $('#deleteModal').modal('hide');
                        toastr.success("Deleted");
                        $("#Kendo-Grid").data("kendoGrid").dataSource.read();
                        $scope.SelectedDataForDelete = {};
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("Network Error");
                    $.LoadingOverlay("hide");
                });
            }


            $scope.Edit = function (data) {
                $scope.addData = data;
            }


            $scope.AddData = function () {
                if ($scope.addData.GradeId == "" && !$scope.addData.IsEmployeeWise) {
                    toastr.warning($scope.LanguageData.SelectGrade);
                } else if ($scope.addData.EmployeeId == "" && $scope.addData.IsEmployeeWise) {
                    toastr.warning("Select Employee");
                } else if ($scope.addData.PayrollComponentId == "") {
                    toastr.warning($scope.LanguageData.SelectLeaveType);
                } else if ($scope.addData.Leaves == 0) {
                    toastr.warning($scope.LanguageData.EnterLeaves);
                } else {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });
                    MainService.AddLeaveAllocation($scope.addData).then(function (response) {
                        if (response.data == "Success") {
                            $("#Kendo-Grid").data("kendoGrid").dataSource.read();
                            toastr.success($scope.LanguageData.Success);
                            $scope.Init();
                        } else {
                            toastr.warning(response.data);
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error($scope.LanguageData.NetworkError);
                        $.LoadingOverlay("hide");
                    });
                }
            }

                }])
